import React, {Component} from 'react'
import Axios from 'axios'
import 'semantic-ui-css/semantic.min.css'
import { Statistic } from 'semantic-ui-react'
import ReactTextTransition from "react-text-transition";


class App extends Component {
  state={registers: 0, companies: 0, receipts: 0}
  async componentDidMount(){
    await this.update()
    setInterval(this.update.bind(this),2000)
  }
  async update(){
    let result = await Axios.get("/stats.php",{
      withCredentials: false,
    })
    this.setState({...result.data})
  }
  render() {
    return (
      <Statistic.Group color="green" widths='three'>
        <Statistic>
          <Statistic.Value>
            {`${this.state.registers}`.split("").map((v,k)=><ReactTextTransition
              text={v}
              key={k}
              order={+v}
              overflow
              direction="down"
              inline
            />
            )}
          </Statistic.Value>
          <Statistic.Label>Kassen</Statistic.Label>
        </Statistic>

        <Statistic>
          <Statistic.Value >
              {`${this.state.receipts}`.split("").map((v,k)=><ReactTextTransition
                text={v}
                key={k}
                order={+v}
                overflow
                direction="down"
                inline
              />
              )}
          </Statistic.Value>
          <Statistic.Label>Kassenbons</Statistic.Label>
        </Statistic>


        <Statistic>
          <Statistic.Value>
            {this.state.companies}
          </Statistic.Value>
          <Statistic.Label>Smarte Unternehmen</Statistic.Label>
        </Statistic>
      </Statistic.Group>
    )
  }
}

export default App
